import { render, staticRenderFns } from "./ManageStandardEquipment.vue?vue&type=template&id=4c06fd4e&scoped=true"
import script from "./ManageStandardEquipment.vue?vue&type=script&lang=js"
export * from "./ManageStandardEquipment.vue?vue&type=script&lang=js"
import style0 from "./ManageStandardEquipment.vue?vue&type=style&index=0&id=4c06fd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06fd4e",
  null
  
)

export default component.exports